import appHoliday from "../../views/appSettings/holiday.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("holiday", {
    url: "holiday/:id",
    parent: "app",
    views: {
      view: {
        template: appHoliday,
      },
    },
    reloadOnSearch: false,
    data: { title: "Holiday" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/holiday/holiday.urls.js